(function ($) {
  "use strict";

  $(function () {
    // Open accordion item if URL hash matches its id
    if (window.location.hash) {
      const hash = window.location.hash.slice(1);
      const $target = $('.qld__accordion-item[id="' + CSS.escape(hash) + '"]');

      if ($target.length) {
        const $collapse = $target.find('.collapse');
        const $button = $target.find('.accordion-button');

        $collapse.collapse('show');
        $button.removeClass('collapsed').attr('aria-expanded', 'true');

        $collapse.one('shown.bs.collapse', function () {
          $target[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    const openClass = "qld__accordion__toggle-btn--open";
    const closedClass = "qld__accordion__toggle-btn--closed";
    const openText = "Open all";
    const closeText = "Close all";

    $(".qld__accordion__toggle-btn").on("click", function () {
      const $btn = $(this);
      const $group = $btn.closest(".qld__accordion-group");
      const $collapsibles = $group.find(".collapse");
      const $headers = $group.find(".accordion-button");

      const isClosed = $btn.hasClass(closedClass);

      if (isClosed) {
        // Open all
        $btn
          .removeClass(closedClass)
          .addClass(openClass)
          .attr("aria-expanded", "true")
          .text(closeText);

        $collapsibles.each(function () {
          const targetId = $(this).attr("id");
          $(this).collapse("show");
          $group
            .find(`.accordion-button[data-bs-target="#${targetId}"]`)
            .removeClass("collapsed")
            .attr("aria-expanded", "true");
        });
      } else {
        // Close all
        $btn
          .removeClass(openClass)
          .addClass(closedClass)
          .attr("aria-expanded", "false")
          .text(openText);

        $collapsibles.each(function () {
          const targetId = $(this).attr("id");
          $(this).collapse("hide");
          $group
            .find(`.accordion-button[data-bs-target="#${targetId}"]`)
            .addClass("collapsed")
            .attr("aria-expanded", "false");
        });
      }
    });
  });
})(jQuery);
